import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Redirect from 'shared/components/Redirect';
var HomeRedirect = function HomeRedirect(_ref) {
  var user = _ref.user;
  var location = useLocation();
  if (!user.loggedIn) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/login".concat(location.search)
    });
  }
  return /*#__PURE__*/React.createElement(Redirect, {
    to: "/rubriq"
  });
};
export default connect(function (_ref2) {
  var user = _ref2.user;
  return {
    user: user
  };
})(HomeRedirect);